<template>
  <h2 class="gradation">注目のファンドニュース</h2>
  <div>
    <div class="news-tile bg-white elevation-2 mb-4 rounded-lg overflow-hidden">
      <router-link :to="{ name: 'selectContent', query: {source_uri: content_uri, title: blogTitle, showSnsShare: true} }" class="text-decoration-none">
        <div class="news-tile__thumbnail " :style="{ backgroundImage: `url(${thumbnailUri})` }">
        </div>
        <div class="news-tile__body pa-3 pt-2">
          <div class="news-tile-body__title">{{ blogTitle }}</div>
          <div class="news-tile-body__fundname">{{ fundName }}</div>
          <div class="news-tile-body__postdate">{{ formattedPostDatetime }}</div>
        </div>
      </router-link>
    </div>
    <v-row class="mx-0">
      <!-- indexが奇数の場合はpr-2 pl-0、偶数の場合はpl-2、pr-0 -->
      <v-col cols="6" v-for="(blog, index) in secondaryBlogs" :key="index" :class="index % 2 === 0 ? 'pr-2 pl-0 pb-1' : 'pl-2 pr-0 pb-1'"> 
        <router-link :to="{ name: 'selectContent', query: {source_uri: `/api/fund/news/${blog.fund_id}/${blog.article_id}`, title: blog.blog_title, showSnsShare: true} }" class="text-decoration-none">
          <div class="news-tile bg-white elevation-2 rounded-lg overflow-hidden">
            <div class="news-tile__thumbnail" :style="{backgroundImage: `url(${blog.thumbnail_uri})`}">
            </div>
            <div class="news-tile__body pa-2">
              <div class="news-tile-body__title small">{{ blog.blog_title }}</div>
              <div class="news-tile-body__fundname">{{ blog.fund_name }}</div>
              <div class="news-tile-body__postdate">{{ formatDate(blog.post_datetime) }}</div>
            </div>
          </div>
        </router-link>
      </v-col>
    </v-row>
    <div class="mt-8">
      <router-link replace :to="{ name: 'contentViewer', query: {page_uri: '/news/fund'} }" class="text-decoration-none">
        <v-btn block color="primary-container" variant="flat" class="rounded-pill">ファンドニュース一覧</v-btn>
      </router-link>
    </div>
  </div>
</template>

<style scoped>
.news-tile {
  position: relative;
}

.news_tile::after {
  content: "";
  position: absolute;
  width: 300%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0.6;
  background: linear-gradient(110deg, rgba(250, 250, 250, 0) 0%, rgba(250, 250, 250, 0) 40%, rgba(250, 250, 250, 0.5) 50%, rgba(250, 250, 250, 0) 60%, rgba(250, 250, 250, 0) 100%);
  animation: gradient-animation_2 1.2s linear infinite;
  display: v-bind(displayLoading);
}

@keyframes gradient-animation_2 {
  0% {
    transform: translateX(-100%);
  }
}

.news-tile__thumbnail {
  width: 100%;
  aspect-ratio: 16 / 9;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-color: #cacaca;
}

.news-tile-body__title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}

.news-tile-body__postdate,
.news-tile-body__fundname {
  font-size: 0.75em;
  color: #666;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
</style>

<script>
import axios from "axios"
import Helper from "../assets/js/helper"

export default {
  name: 'FundNews',
  props: {
  },
  data() {
    return {
      blogTitle: '',
      postDatetime: '',
      fundName: '',
      thumbnailUri: '',
      displayLoading: 'block',
      content_uri: '',
      secondaryBlogs: [],
    }
  },
  created: function () {
  },
  computed: {
    formattedPostDatetime() {
      return Helper.formatDate(this.postDatetime);
    }
  },
  async mounted() {
    this.fetchContent()
  },
  methods: {
    async fetchContent() {
      const response = await axios.get('/api/fund/top_news').catch(() => {
        return;
      });
      var primaryBlogs = response.data.shift();
      this.blogTitle = primaryBlogs.blog_title
      this.postDatetime = primaryBlogs.post_datetime
      this.fundName = primaryBlogs.fund_name
      this.thumbnailUri = primaryBlogs.thumbnail_uri
      this.content_uri = `/api/fund/news/${primaryBlogs.fund_id}/${primaryBlogs.article_id}`

      this.secondaryBlogs = response.data
      this.$nextTick(() => {
        this.displayLoading = 'none'
      });
    },
    formatDate(date) {
      return Helper.formatDate(date);
    }
  }
}
</script>